<template>
<v-card
  class="grey lighten-4 ma-4"
  elevation="10"
  :disabled='request.loading' :loading='request.loading' >
  <request-status
    :request='request'
    message201='Successfully created new appointment type' />
  <v-card-title class='pt-2' >
    <span class='overline' >Add a new appointment type</span>
    <v-spacer/>
    <!-- <pre v-text='practitioner' /> -->
    <!-- {{selectedSpaceId}}|{{selectedpractitionerId}} -->
    <span v-if="spaceId" >@ {{spaceName}}</span>
    <v-menu v-else >
      <template v-slot:activator="{ on }">
        <v-btn v-on='on' slot='activator' small color='accent' class='mr-2' >
          <span v-if='selectedSpaceId' >@ {{spaceName}}</span>
          <span v-else >Choose a space</span>
          <v-icon small class='ml-2' >mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list dense class='pa-0'>
        <v-list-item
          v-for="space in spaces"
          :key='space.id'
          @click='selectedSpaceId = space.id' >
          <v-list-item-content>
            <v-list-item-title v-text='space.title' />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <span class='ml-2' v-if="practitionerId" >with {{practitionerName}}</span>
    <v-menu v-else >
      <template v-slot:activator="{ on }">
        <v-btn v-on='on' slot='activator' small color='accent' >
          <span v-if='selectedPractitionerId' >{{practitionerName}}</span>
          <span v-else >Choose a practitioner</span>
          <v-icon small class='ml-2' >mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list dense class='pa-0' >
        <v-list-item
          v-for="practitioner in practitioners"
          :key='practitioner.id'
          @click='selectedpractitionerId = practitioner.id' >
          <v-list-item-content>
            <v-list-item-title v-text='practitioner.full_name' />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-spacer/>
    <v-btn @click='$emit("close")' icon >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider />
  <template v-if="selectedSpaceId && selectedPractitionerId" >
    <v-card-text
      class='py-0' >
    <v-row >
      <v-col
        v-for='field in fields' :key='field.id'
        cols='12' md='3' >
        <v-text-field
          v-model="product[field.id]"
          v-bind='field.attrs' />
      </v-col>
      <v-col cols='12' md='3' >
        <location-picker :dense=false :return-object='false'
          v-model="product.locations"
          :space-id="spaceId"
          :attrs="{chips: true, smallChips: true}" />
      </v-col>
    </v-row>
    </v-card-text>
    <!-- <pre v-text="product" /> -->
    <v-card-actions >
      <v-btn @click="$emit('close')" text >Cancel</v-btn>
      <v-spacer/>
      <v-btn @click='create' :disabled="!isValid" color='primary' >Create</v-btn>
    </v-card-actions>
  </template>
  <v-card-text v-else >
    <div v-if="!selectedSpaceId" >Please choose a space for this appointment type</div>
    <div v-if="!selectedPractitionerId" >Please choose a practitioner</div>
  </v-card-text>

</v-card>
</template>
<script>
import LocationPicker from '@/components/pickers/LocationPicker.vue'
import { mapGetters } from 'vuex'

function getInitialProduct () {
  return {
    title: '',
    price: 500,
    duration: 30,
    locations: null
  }
}

export default {
  name: 'QuickAppointmentTypeForm',
  components: {LocationPicker},
  props: {
    spaceId: {required: false},
    practitionerId: {required: false}
  },
  data () {
    return {
      selectedSpaceId: null,
      selectedpractitionerId: null,
      product: {
        title: '',
        price: 500,
        duration: 30,
        locations: null
      },
      request: {
        resource: 'ag.spaces',
        extra: 'appointment-types'
      },
      fields: [
        {
          id: 'title',
          attrs: {
            autofocus: true,
            label: 'title'
          }
        },
        {
          id: 'duration',
          attrs: {
            type: 'Number',
            label: 'duration',
            suffix: 'mins'
          }
        },
        {
          id: 'price',
          attrs: {
            type: 'Number',
            label: 'price',
            prefix: ''
          }
        }
        // { id: 'locations', attrs: { label: 'locations' } }
      ]
    }
  },
  mounted () {
    this.fields[2].attrs.prefix = this.currency
    if (!this.selectedSpaceId && this.spaces.length === 1) {
      this.selectedSpaceId = this.spaces[0].id
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) { this.selectedSpaceId = this.spaceId }
      }
    },
    practitionerId: {
      immediate: true,
      handler () {
        if (this.practitionerId) {
          this.selectedPractitionerId = this.practitionerId
        }
      }
    },
    requestStatus () {
      if (this.requestStatus === 201) {
        this.clear()
        this.$emit('input', this.request.result)
      }
    }
  },
  methods: {
    create () {
      this.request.resourceId = this.selectedSpaceId
      this.request.data = this.product
      this.request.data.practitioner = this.selectedPractitionerId
      this.request.data.service = this.selectedSpaceId
      this.request.method = 'post'
      this.$request('save', this.request)
    },
    clear () {
      this.product = getInitialProduct()
    }
  },
  computed: {
    ...mapGetters('identity', [
      'getSpaceById',
      'getPractitionerById',
      'getSpacesByPractitionerId',
      'spacesList',
      'practitionersList',
      'getPractitionersInSpace'
    ]),
    isValid () {
      return (
        this.selectedPractitionerId &&
        this.selectedSpaceId &&
        this.product.title &&
        this.product.price &&
        this.product.duration &&
        this.product.locations &&
        this.product.locations.length
      )
    },
    requestStatus () { return this.request.status },
    practitioner () { return this.getPractitionerById(this.practitionerId) },
    practitionerName () { return this.getObjectPath(this.practitioner, 'full_name') },
    space () { return this.getSpaceById(this.selectedSpaceId) },
    spaceName () { return this.getObjectPath(this.space, 'title') },
    spaces () {
      if (this.practitionerId) {
        return this.getSpacesByPractitionerId(this.practitionerId)
      } else {
        return this.spacesList
      }
    },
    practitioners () {
      if (this.spaceId) {
        return this.getPractitionersInSpace(this.spaceId)
      } else {
        return this.practitionersList
      }
    }
  }
}
</script>
